import { render } from "./ProductSolutionDetail.vue?vue&type=template&id=7a265ee2&scoped=true"
import script from "./ProductSolutionDetail.vue?vue&type=script&lang=js"
export * from "./ProductSolutionDetail.vue?vue&type=script&lang=js"

import "./ProductSolutionDetail.vue?vue&type=style&index=0&id=7a265ee2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a265ee2"],['__file',"src/views/h5/ai/solution/ProductSolutionDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7a265ee2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7a265ee2', __exports__)) {
    api.reload('7a265ee2', __exports__)
  }
  
  module.hot.accept("./ProductSolutionDetail.vue?vue&type=template&id=7a265ee2&scoped=true", () => {
    api.rerender('7a265ee2', render)
  })

}


export default __exports__